(() => {
  const bar = document.querySelector('[data-sticky-atc]');
  const anchor = bar && document.getElementById(bar.dataset.anchor);
  const price = bar && document.getElementById(bar.dataset.priceAnchor);
  const mobile = window.matchMedia('(max-width: 749px)');

  if (bar && anchor) {
    document.body.appendChild(bar);
    let queued = false;

    const update = () => {
      queued = false;
      const scrolledPast =
        anchor.getBoundingClientRect().bottom < 0 && (!price || price.getBoundingClientRect().bottom < 0);
      const visible = scrolledPast && mobile.matches;
      bar.hidden = !visible;
      document.body.classList.toggle('monti-sticky-atc-visible', visible);
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mobile.addEventListener('change', update);
    update();

    const button = bar.querySelector('.monti-sticky-atc__button');
    const spinner = button && button.querySelector('.loading__spinner');
    if (button) {
      const setLoading = (loading) => {
        button.classList.toggle('loading', loading);
        button.setAttribute('aria-disabled', String(loading));
        if (spinner) spinner.classList.toggle('hidden', !loading);
      };
      const syncWithForm = () => setLoading(anchor.classList.contains('loading'));

      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (button.getAttribute('aria-disabled') === 'true' || anchor.disabled) return;
        setLoading(true);
        anchor.click();
      });
      new MutationObserver(syncWithForm).observe(anchor, { attributes: true, attributeFilter: ['class'] });
    }
  }

  document.querySelectorAll('[data-collapsible-description]').forEach((wrapper) => {
    const content = wrapper.querySelector('[data-collapsible-content]');
    const toggle = wrapper.querySelector('[data-collapsible-toggle]');
    if (!content || !toggle) return;

    const measure = () => {
      if (wrapper.classList.contains('is-expanded')) return;
      wrapper.classList.remove('is-short');
      if (content.scrollHeight <= content.clientHeight + 40) wrapper.classList.add('is-short');
    };

    const setExpanded = (expanded, trigger) => {
      wrapper.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
      wrapper.dispatchEvent(new CustomEvent('monti:description-toggle', { bubbles: true, detail: { expanded, trigger } }));
    };

    toggle.addEventListener('click', () => setExpanded(!wrapper.classList.contains('is-expanded'), 'button'));
    content.addEventListener('click', (event) => {
      if (wrapper.classList.contains('is-expanded') || wrapper.classList.contains('is-short')) return;
      if (event.target.closest('a')) return;
      setExpanded(true, 'text');
    });

    measure();
    mobile.addEventListener('change', measure);
    window.addEventListener('resize', measure, { passive: true });
  });
})();
